import { liteClient as algoliasearch, type LiteClient } from 'algoliasearch/lite';

/**
 * Algolia 検索クライアントの単一インスタンスを構築する。
 *
 * 同一画面内で複数 InstantSearch を扱う場合でも searchClient は使い回せるよう
 * Module スコープでキャッシュする（runtimeConfig は SSR/CSR で同一）。
 */

let cachedClient: LiteClient | null = null;
let cachedAppId: string | null = null;

export const useAlgoliaSearchClient = () => {
  const runtimeConfig = useRuntimeConfig();
  const appId = runtimeConfig.public.ALGOLIA_APP_ID as string;
  const apiKey = runtimeConfig.public.ALGOLIA_SEARCH_API_KEY as string;
  const indexName = runtimeConfig.public.ALGOLIA_INDEX_NAME as string;

  if (!appId || !apiKey || !indexName) {
    throw new Error('Algolia の設定が不足しています（ALGOLIA_APP_ID / ALGOLIA_SEARCH_API_KEY / ALGOLIA_INDEX_NAME）');
  }

  if (!cachedClient || cachedAppId !== appId) {
    cachedClient = algoliasearch(appId, apiKey);
    cachedAppId = appId;
  }

  return {
    searchClient: cachedClient,
    indexName,
  };
};
